/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PersonUpdateRequest model module.
 * @module model/PersonUpdateRequest
 * @version v0
 */
export default class PersonUpdateRequest {
  /**
   * Constructs a new <code>PersonUpdateRequest</code>.
   * @alias module:model/PersonUpdateRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PersonUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PersonUpdateRequest} obj Optional instance to populate.
   * @return {module:model/PersonUpdateRequest} The populated <code>PersonUpdateRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PersonUpdateRequest();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
PersonUpdateRequest.prototype.id = undefined;

/**
 * @member {String} email
 */
PersonUpdateRequest.prototype.email = undefined;

/**
 * @member {String} firstname
 */
PersonUpdateRequest.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
PersonUpdateRequest.prototype.lastname = undefined;

